export default __webpack_public_path__ + "static/media/EV-range-mobile.48ee0723.png";